import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import storeManager from '../../../store/StoreManager';
import configuration from '../../../constants/Configuration';
import appParameters from '../../utils/AppParameters';
import properties from '../../../constants/Properties';
import hoverManager from '../../utils/HoverManager';
import audioToolUtils from '../utils/AudioToolUtils';
import playController from '../../utils/PlayController';
import { setMarkerPosition } from '../../../actions/AudioEditorActions';
import { VolumeSlider } from '../../menus/VolumeSlider';
import exporterUtils from '../../utils/ExporterUtils';
import platformDetection from '../../utils/PlatformDetection';
import mouseUtils from '../../utils/MouseUtils';
import locales from '../../../locales/LocalesManager';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onButtonMouseIn() {
        switch (this.props.index) {
            case 0: { // Start
                hoverManager.show(this.refs.holder, 'startAudio');
                break;
            }
            case 1: { // Back with 10s
                hoverManager.show(this.refs.holder, 'backAudio');
                break;
            }
            case 2: { // Play
                if (playController.isPlaying)
                    hoverManager.show(this.refs.holder, 'previewModePauseCartoon');
                else
                    hoverManager.show(this.refs.holder, 'previewModePlayCartoon');

                break;
            }
            case 3: { // Next with 10s
                hoverManager.show(this.refs.holder, 'nextAudio');
                break;
            }
            case 4: { // End
                hoverManager.show(this.refs.holder, 'endAudio');
                break;
            }
            case 5: { // Volume
                hoverManager.show(this.refs.holder, 'changeVolume', 'left');
                break;
            }
        }

        this.setState({
            isOver: true
        });
    },
    getButtonAriaLabel() {
        var text = '';

        switch (this.props.index) {
            case 0: { // Start
                text = locales.getCaption('startAudio', 'hover');
                break;
            }
            case 1: { // Back with 10s
                text = locales.getCaption('backAudio', 'hover');
                break;
            }
            case 2: { // Play
                if (playController.isPlaying)
                    text = locales.getCaption('previewModePauseCartoon', 'hover');
                else
                    text = locales.getCaption('previewModePlayCartoon', 'hover');

                break;
            }
            case 3: { // Next with 10s
                text = locales.getCaption('nextAudio', 'hover');
                break;
            }
            case 4: { // End
                text = locales.getCaption('endAudio', 'hover');
                break;
            }
            case 5: { // Volume
                text = locales.getCaption('changeVolume', 'hover');
                break;
            }
        }

        return text;
    },
    onButtonMouseOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    rejectMouseUpEvent() {
        if (platformDetection.isChromeBook()) {
            var currentTime = new Date().getTime();
            var lastClickTime = mouseUtils.mouseUpTime;

            if (lastClickTime != 0 && (currentTime - lastClickTime) < 100)
                return true;
            else
                return false;
        } else
            return false;
    },
    onClick() {
        hoverManager.hide();

        if (platformDetection.isIOS())
            return;

        if (this.rejectMouseUpEvent())
            return;

        mouseUtils.mouseUpTime = new Date().getTime();

        if (this.props.handleAction)
            this.props.handleAction(this.props.index);
    },
    onTouchEnd() {
        hoverManager.hide();

        if (this.rejectMouseUpEvent())
            return;

        mouseUtils.mouseUpTime = new Date().getTime();

        if (this.props.handleAction)
            this.props.handleAction(this.props.index);
    },
    getSoundIcon() {
        const state = storeManager.getState();
        var soundVolume = state.audioEditor.volume;

        if (soundVolume == undefined)
            soundVolume = 0.5;

        var volumeIcon = 'fa fa-volume-down fa-2x';

        if (soundVolume == 0)
            volumeIcon = 'fa fa-volume-off fa-2x';
        else if (soundVolume <= 0.5)
            volumeIcon = 'fa fa-volume-down fa-2x';
        else if (soundVolume > 0.5)
            volumeIcon = 'fa fa-volume-up fa-2x';

        return volumeIcon;
    },
    render() {
        var leftPosition;
        const middle = this.props.barWidth / 2;
        const isMobileValue = (window.outerWidth < 450 && window.outerWidth > 0) || (window.outerHeight < 450 && window.outerHeight > 0);
        const buttonSize = isMobileValue ? 28 : properties.PREVIEW_HEIGHT;
        var gap = properties.PREVIEW_BUTTONS_GAP * 2;

        switch (this.props.index) {
            case 0: {
                leftPosition = middle - buttonSize/ 2 - gap* 2 - buttonSize * 2;
                break;
            }
            case 1: {
                leftPosition = middle - buttonSize / 2 - gap - buttonSize;
                break;
            }
            case 2: {
                leftPosition = middle - buttonSize / 2;
                break;
            }
            case 3: {
                leftPosition = middle + buttonSize / 2 + gap;
                break;
            }
            case 4: {
                leftPosition = middle + buttonSize / 2 + gap * 2 + buttonSize;
                break;
            }
            case 5: {
                leftPosition = this.props.barWidth - buttonSize - 25;
                break;
            }
        }

        const buttonStyle = {
            width: buttonSize,
            height: properties.PREVIEW_HEIGHT,
            position: 'absolute',
            left: leftPosition,
            top: 0,
            cursor: 'pointer',
            background: 'none',
            borderStyle: 'none'
        };

        var iconSrc = this.props.src;

        const iconSize = this.props.index == 2 ? properties.PREVIEW_BUTTON_SIZE * 2 : properties.PREVIEW_BUTTON_SIZE * 1.5;
        var opacity = 1;
        var iconStyle;
        var iconElement;

        if (this.state.isOver == true && !platformDetection.isIOS())
            opacity = 0.4;

        if (this.props.index == 5) { // volume button
            iconStyle = {
                position: 'absolute',
                top: 5,
                left: 10,
                color: '#4b4c4c',
                opacity: opacity
            };

            iconElement = <i style={iconStyle} className={this.getSoundIcon()}></i>;
        } else {
            iconStyle = {
                position: 'absolute',
                top: buttonSize / 2 - iconSize / 2,
                left: buttonSize / 2 - iconSize / 2,
                width: iconSize,
                height: iconSize,
                opacity: opacity
            };

            iconElement = <img alt='' aria-hidden='true' style={iconStyle} src={iconSrc}/>;
        }

        var elementId = 'audioElementVolume_' + this.props.index;

        if (this.props.index == 2)
            elementId = 'playButtonElement';

        return (
            <button aria-label={this.getButtonAriaLabel()} ref='holder' id={elementId} style={buttonStyle} onTouchEnd={this.onTouchEnd} onClick={this.onClick} onMouseOver={this.onButtonMouseIn} onMouseOut={this.onButtonMouseOut}>
                {iconElement}
            </button>
        );
    }
});

const AudioToolPlayerContent = React.createClass({
    getInitialState() {
        return {
            isPlaying: false,
            isPlayheadOver: false,
            openVolumeSlider: false
        };
    },
    componentDidMount() {
        exporterUtils.init();
        playController.updateRecordingMenuButtons = this.updateButtons;
        audioToolUtils.audioPlayerKeyboardShortcutAction = this.handleAction;

        document.addEventListener('mousedown', this.onCloseVolumeSlider);
        document.addEventListener('touchstart', this.onCloseVolumeSlider);
    },
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onCloseVolumeSlider);
        document.removeEventListener('touchstart', this.onCloseVolumeSlider);
    },
    onCloseVolumeSlider (e) {
        const target = e.target;

        var volume = 'audioElementVolume_5';

        if (target == undefined || (target && target.id == volume) || (target.parentElement && target.parentElement.id == volume))
            return;

        if (target.id && target.id.indexOf('volumeIcon') != -1) {
            this.setState({
                openVolumeSlider: false
            });

            return;
        }

        if (target.id.indexOf('volumeSlider') != -1 || (target.parentElement && target.parentElement.id.indexOf('volumeSlider') != -1) || (target.parentElement && target.parentElement.parentElement && target.parentElement.parentElement.id.indexOf('volumeSlider') != -1))
            return;

        this.setState({
            openVolumeSlider: false
        });
    },
    updateButtons() {
        this.setState({
            isPlaying: false
        });
    },
    handleAction(index) {
        if (index == 2) { // Play
            this.doPlay();
            return;
        }

        if (index == 5) { // Volume
            this.setState({
                openVolumeSlider: true
            });
            return;
        }

        if (this.state.isPlaying)
            playController.pause();

        var newPosition;

        switch (index) {
            case 0: { // Start
                newPosition = 0;
                break;
            }
            case 1: { // back with 10s
                newPosition = this.props.markerPosition - 10;
                break;
            }
            case 3: { // next with 10s
                newPosition = this.props.markerPosition + 10;
                break;
            }
            case 4: { // end
                newPosition = audioToolUtils.totalTime;
                break;
            }
        }

        if (newPosition < 0)
            newPosition = 0;

        if (newPosition > audioToolUtils.totalTime)
            newPosition = audioToolUtils.totalTime;

        this.props.dispatch(setMarkerPosition(newPosition));

        if (this.state.isPlaying)
            playController.play();
    },
    doPlay() {
        if (this.state.isPlaying)
            playController.pause();
        else
            playController.play();

        this.togglePlayState();
    },
    togglePlayState() {
        if (!this.state.isPlaying) {
            this.setState({
                isPlaying: true
            });
        } else {
            this.setState({
                isPlaying: false
            });
        }
    },
    onTrackClick(e) {
        if (playController.isPlaying)
            return;

        if (e.target && e.target.id == 'playHead')
            return;

        var localX = e.nativeEvent.offsetX;

        if (e.nativeEvent.touches && e.nativeEvent.touches.length > 0)
            localX = e.nativeEvent.touches[0].clientX - 130;

        var markerPosition = audioToolUtils.getMarkerTime(localX);
        this.props.dispatch(setMarkerPosition(markerPosition));
    },
    onMouseDown () {
        var leftString = this.refs.thumb.style.left;
        var left = Number(leftString.substring(0, leftString.length - 2)) + properties.PLAYHEAD_SIZE / 2;

        this.setState({
            startPosition: left,
            isThumbActive: true
        });
    },
    onMouseMove (e, coreEvent) {
        this.checkPosition(coreEvent.lastX);
    },
    onMouseUp (e, coreEvent) {
        this.checkPosition(coreEvent.lastX);

        this.setState({
            isThumbActive: false
        });
    },
    checkPosition(deltaX) {
        var newPosition = (this.state.startPosition +  deltaX);

        if (newPosition < 0)
            newPosition = 0;
        else if (newPosition > audioToolUtils.trackWidth)
            newPosition = audioToolUtils.trackWidth;

        this.props.dispatch(setMarkerPosition(audioToolUtils.getMarkerTime(newPosition)));
    },
    onPlayheadMouseIn() {
        this.setState({
            isPlayheadOver: true
        });
    },
    onPlayheadMouseOut() {
        this.setState({
            isPlayheadOver: false
        });
    },
    render() {
        const width = configuration.CANVAS_WIDTH * this.props.scaleProperties.scale;
        const height = configuration.CANVAS_HEIGHT * this.props.scaleProperties.scale;

        var menuStyle = {
            position: 'absolute',
            background: 'blue',
            width: width,
            height: height,
            top: this.props.scaleProperties.topY,
            left: this.props.scaleProperties.topX,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none'
        };

        const backgroundStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: menuStyle.width,
            height: height - properties.PLAYER_BAR_HEIGHT,
            background: '#ffb02d'
        };

        // image size 367x258
        const backgroundIconStyle = {
            position: 'absolute',
            top: backgroundStyle.height / 2 - 258 / 2,
            left: width / 2 - 367 / 2
        };

        var src = appParameters.RESOURCES_LOCATION() + 'assets/audioPlayerBackground.png';

        const barStyle = {
            position: 'absolute',
            top: height - properties.PLAYER_BAR_HEIGHT,
            left: 0,
            width: width,
            height: properties.PLAYER_BAR_HEIGHT,
            background: '#ebeae8'
        };

        const buttonsHolderStyle = {
            position: 'absolute',
            top: properties.PLAYER_BAR_HEIGHT / 2,
            left: 0,
            width: width,
            height: properties.PLAYER_BAR_HEIGHT / 2
        };

        const controlBarStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: width,
            height: properties.PLAYER_BAR_HEIGHT / 2
        };

        var textHeight = 20;
        var textWidth = 130;

        const leftSpanStyle = {
            color: 'black',
            fontSize: 18,
            cursor: 'default',
            position: 'absolute',
            textAlign: 'center',
            width: textWidth,
            height: textHeight,
            left: 0,
            top: controlBarStyle.height / 2 - textHeight / 2
        };

        const rightSpanStyle = {
            color: 'black',
            fontSize: 18,
            cursor: 'default',
            position: 'absolute',
            textAlign: 'center',
            width: textWidth,
            height: textHeight,
            left: width - textWidth,
            top: controlBarStyle.height / 2 - textHeight / 2
        };

        const trackHeight = 10;
        const playhedSize = properties.PLAYHEAD_SIZE;
        const trackStyle = {
            position: 'absolute',
            width: width - 2 * textWidth,
            height: playhedSize,
            left: textWidth,
            top: controlBarStyle.height / 2 - playhedSize / 2
        };

        audioToolUtils.checkTotalTime(trackStyle.width);
        const currentPosition = audioToolUtils.getMarkerPosition(this.props.markerPosition);
        const trackNormalStyle = {
            position: 'absolute',
            background: '#898b8b',
            width: trackStyle.width,
            height: trackHeight,
            left: 0,
            top: trackStyle.height / 2 - trackHeight / 2
        };

        const trackShadowStyle = {
            position: 'absolute',
            background: '#00B3EC',
            width: currentPosition,
            height: trackHeight,
            left: 0,
            top: trackStyle.height / 2 - trackHeight / 2
        };

        var playheadStyle = {
            position: 'absolute',
            background: 'white',
            width: playhedSize,
            height: playhedSize,
            left: currentPosition - playhedSize / 2,
            top: trackStyle.height / 2 - playhedSize / 2,
            borderRadius: 50,
            boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
            cursor: 'pointer'
        };

        if (this.state.isThumbActive || this.state.isPlayheadOver)
            playheadStyle.background = '#ffb02d';

        var playSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/play.png';

        if (this.state.isPlaying)
            playSrc = appParameters.RESOURCES_LOCATION() + 'assets/player/pause.png';


        const isMobileValue = (window.outerWidth < 450 && window.outerWidth > 0) || (window.outerHeight < 450 && window.outerHeight > 0);
        const volumeSliderOffset = isMobileValue ? 57 : 67;

        return (
            <div style={menuStyle}>
                <div style={backgroundStyle}>
                    <img alt='' aria-hidden='true' style={backgroundIconStyle} src={src}/>
                </div>

                <div style={barStyle}>
                    <div style={controlBarStyle}>
                        <span style={leftSpanStyle}>{audioToolUtils.getCurrentTime(this.props.markerPosition)}</span>
                        <span style={rightSpanStyle}>{audioToolUtils.getTotalTime()}</span>
                        <div style={trackStyle} onTouchStart={this.onTrackClick} onMouseDown={this.onTrackClick}>
                            <div style={trackNormalStyle}/>
                            <div style={trackShadowStyle}/>
                            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                                <div style={playheadStyle} id='playHead' ref='thumb' onMouseOver={this.onPlayheadMouseIn} onMouseOut={this.onPlayheadMouseOut}/>
                            </Draggable>
                        </div>
                    </div>

                    <div style={buttonsHolderStyle}>
                        <Button dispatch={this.props.dispatch} index={0} src={appParameters.RESOURCES_LOCATION() + 'assets/player/start.png'} barWidth={width} handleAction={this.handleAction}/>
                        <Button dispatch={this.props.dispatch} index={1} src={appParameters.RESOURCES_LOCATION() + 'assets/player/goBack.svg'} barWidth={width} handleAction={this.handleAction}/>
                        <Button dispatch={this.props.dispatch} index={2} src={playSrc} barWidth={width} handleAction={this.handleAction}/>
                        <Button dispatch={this.props.dispatch} index={3} src={appParameters.RESOURCES_LOCATION() + 'assets/player/goNext.svg'} barWidth={width} handleAction={this.handleAction}/>
                        <Button dispatch={this.props.dispatch} index={4} src={appParameters.RESOURCES_LOCATION() + 'assets/player/end.png'} barWidth={width} handleAction={this.handleAction}/>
                        <Button dispatch={this.props.dispatch} index={5} barWidth={width} handleAction={this.handleAction}/>

                        <VolumeSlider dispatch={this.props.dispatch} visible={this.state.openVolumeSlider} type={'audioToolPlayer'} positionLeft={width - volumeSliderOffset}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    var markerPosition = state.audioEditor.markerPosition;
    var volume = state.audioEditor.volume;

    if (!markerPosition)
        markerPosition = 0;

    if (volume == undefined)
        volume = 0.5;

    return {
        markerPosition,
        volume
    };
}

export const AudioToolPlayer = connect(mapStateToProps)(AudioToolPlayerContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioTool/menus/AudioToolPlayer.js
 **/